/**
 * The external dependencies.
 */
import React from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
import * as R from 'ramda';
/**
 * The internal dependencies.
 */
import FlexRootWrapper from '../../../components/general/flex-root';
import Bar from '../../../components/task/bar';
import Sidebar from '../../../components/task/shop/sidebar';
import Form from '../../../containers/task/shop/form';
import {tasksDeselect, tasksUpdate} from '../../../store/tasks/actions';
import {getcurrentChildren, getTasksCurrent} from '../../../store/tasks/selectors';
import {callRoute} from '../../../common/api';

const ContentWrapper = styled(FlexRootWrapper)`
	flex-direction: row;
`;


class Task extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            image: ""
        }
    }

    async componentDidMount() {
        await callRoute(['getTasksSteps', {
            client: this.props.task.order_client,
            erpnumber: this.props.task.erpnumber
        }]).then((response) => {
            if (response.data._embedded) {
                this.setState({
                    image: response.data._embedded.instruction[0]._links.resourcesEntity.href
                });
            }
        })


    }

    setDate(setDate) {
        const {task, tasksUpdate} = this.props;
        tasksUpdate(task.id, {date: setDate});
    }

    render() {
        const {task, tasksDeselect, children} = this.props;
        console.log("task.departmentEntityList", task.departmentEntityList);
        const departments = task.departmentEntityList ? R.join(',', task.departmentEntityList) : '';
        const childrenErp = R.pluck('erpnumber', children);

        return (
            <FlexRootWrapper>
                <Bar
                    longNumber={task.erpnumber}
                    task={task}
                    onClose={tasksDeselect}
                />


                <ContentWrapper>
                    <Sidebar
                        taskImage={this.state.image}
                        taskShortNumber={task.erpnumber}
                        taskTotalQuantity={task.order_quantity}
                        taskCustomer={task.order_client}
                        taskDate={task.date}
                        setDate={(date) => {
                            this.setDate(date)
                        }}
                        taskDepartments={departments}
                        task={task}
                        children={children}
                        taskDeliveryDate={task.order_deadline}
                    />
                    <Form/>
                </ContentWrapper>
            </FlexRootWrapper>
        );
    }
}

export default connect(
    (state) => ({
        task: getTasksCurrent(state),
        children: getcurrentChildren(state),
    }), {
        tasksDeselect,
        tasksUpdate
    }
)(Task);



// WEBPACK FOOTER //
// ./src/containers/task/shop/index.js